define.alias("shared/components/shared/post/copy/modal", "calendar/components/shared/post/copy/modal/index");